export default {
  components: {
    logo: () => import('./components/logo'),
    socialIcons: () => import('./components/social-icons')
  }
}



// WEBPACK FOOTER //
// ./src/App.vue.js